(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marine-social-follow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marine-social-video')) {
    class MarineSocialVideo extends HTMLElement {
      connectedCallback() {
        // The cover markup is kept so a stopped video can show its cover and play button again
        if (!this.hasAttribute('data-loaded')) this.cover = this.innerHTML;
        this.bindPlay();

        // Moving to another slide stops the video that was playing
        this.slider = this.closest('slider-component');
        if (this.slider) {
          this.onSlideChanged = () => this.reset();
          this.slider.addEventListener('slideChanged', this.onSlideChanged);
        }
      }

      disconnectedCallback() {
        if (this.slider) this.slider.removeEventListener('slideChanged', this.onSlideChanged);
      }

      bindPlay() {
        const button = this.querySelector('.marine-social-follow__play');
        if (button) button.addEventListener('click', () => this.load(), { once: true });
      }

      reset() {
        if (!this.hasAttribute('data-loaded') || this.cover === undefined) return;
        this.innerHTML = this.cover;
        this.removeAttribute('data-loaded');
        this.bindPlay();
      }

      load() {
        const id = this.dataset.id;
        if (!id) return;
        // Only one video plays at a time in the section
        const section = this.closest('.marine-social-follow');
        if (section) {
          section.querySelectorAll('marine-social-video[data-loaded]').forEach((player) => {
            if (player !== this) player.reset();
          });
        }
        const src =
          this.dataset.type === 'vimeo'
            ? `https://player.vimeo.com/video/${id}?autoplay=1`
            : `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = this.dataset.title || '';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        this.replaceChildren(iframe);
        this.setAttribute('data-loaded', '');
        iframe.focus();
      }
    }

    customElements.define('marine-social-video', MarineSocialVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
